import { combineReducers } from 'redux';

import brandsByDealerIdReducer from './brandsByDealerIdReducer';
import brandsByGroupIdReducer from './brandsByGroupIdReducer';
import brandsByIdReducer from './brandsByIdReducer';

export default combineReducers({
  byDealerId: brandsByDealerIdReducer,
  byGroupId: brandsByGroupIdReducer,
  byId: brandsByIdReducer,
});
